export default __webpack_public_path__ + "static/media/ai.c9bfd741.svg";